import { render, staticRenderFns } from "./card-faq-rivoneed.vue?vue&type=template&id=3f1d784c&scoped=true&"
import script from "./card-faq-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-faq-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-faq-rivoneed.vue?vue&type=style&index=0&id=3f1d784c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d784c",
  null
  
)

export default component.exports